var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRejectShipments(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 51.69 58.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#134fc8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45,34.49H15A1.25,1.25,0,1,0,15,37H45a1.25,1.25,0,1,0,0-2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.35,39.89H15a1.25,1.25,0,0,0,0,2.5H27.35a1.25,1.25,0,0,0,0-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45,39.89H32.62a1.25,1.25,0,1,0,0,2.5H45a1.25,1.25,0,0,0,0-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.88,0H13.09A4.81,4.81,0,0,0,8.28,4.81V45.33H0v8.8a4.81,4.81,0,0,0,4.81,4.81H46.88a4.81,4.81,0,0,0,4.81-4.81V4.81A4.81,4.81,0,0,0,46.88,0ZM4.81,56.39a2.27,2.27,0,0,1-2.26-2.26V47.88H38.61v5.33a3.26,3.26,0,0,0,2.1,3.18Zm44.33-2.26a2.27,2.27,0,0,1-2.26,2.26h-1c-2.15,0-4.77-1.93-4.77-4.09v-7H10.83V4.81a2.27,2.27,0,0,1,2.26-2.26H46.88a2.27,2.27,0,0,1,2.26,2.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "28.32 18.32 28.98 22.36 30.98 22.36 31.65 18.32 31.98 10.52 27.99 10.52 28.32 18.32"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 28.32,
    y: 24.32,
    width: 3.33,
    height: 3.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30,5.76A13.23,13.23,0,1,0,43.22,19,13.23,13.23,0,0,0,30,5.76ZM30,30.1A11.11,11.11,0,1,1,41.09,19,11.12,11.12,0,0,1,30,30.1Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectShipments);
export default __webpack_public_path__ + "static/media/reject-shipments.032f53112dba514c10f32cbee14ef1dc.svg";
export { ForwardRef as ReactComponent };